import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogType } from '@type/dialog-type';
import { messages } from '@configuration/messages';

@Component({
  selector: 'app-edit-image-dialog',
  templateUrl: './edit-image-dialog.component.html',
  styleUrls: ['./edit-image-dialog.component.scss'],
})
export class EditImageDialogComponent implements OnInit {
  private description: String = '';
  public static cssClass: DialogType = 'black-centered-dialog';
  public messages = messages;
  public maxlength = 200;
  public form: FormGroup = new FormGroup({
    description: new FormControl('', [Validators.maxLength(this.maxlength)]),
  });

  constructor(
    private dialogRef: MatDialogRef<EditImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
  ) {
    this.description = this.data.description;
    this.form.setValue({ description: this.description });
  }

  ngOnInit(): void {}
  public save() {
    this.dialogRef.close({
      description: this.form.controls.description.value,
    });
  }
  public closeDialog() {
    this.dialogRef.close();
  }
}
